/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Geo_BadgeInputs */

const en_directory_hubs_signals_geo_badge = /** @type {(inputs: Directory_Hubs_Signals_Geo_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GEO-Score`)
};

const zh_directory_hubs_signals_geo_badge = /** @type {(inputs: Directory_Hubs_Signals_Geo_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GEO-Score`)
};

/**
* | output |
* | --- |
* | "GEO-Score" |
*
* @param {Directory_Hubs_Signals_Geo_BadgeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_geo_badge = /** @type {((inputs?: Directory_Hubs_Signals_Geo_BadgeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Geo_BadgeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_geo_badge(inputs)
	return zh_directory_hubs_signals_geo_badge(inputs)
});
export { directory_hubs_signals_geo_badge as "directory.hubs.signals.geo.badge" }